import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class MultaRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.MULTAS);
  }

  public recusarIndicacaoCondutor(codigoMulta: string): Observable<any> {
    return this.customClient.put(`${this.basePath}/recusar-indicacao-condutor`, { codigoMulta }).pipe(
      (data: any) => (data ? data : this.handleResponseRequest(data))
    );
  }
}
